const GENDER_ACCENT: Record<number, string> = {
  1: '#98AC82',
  2: '#D2711A',
  4: '#F3BD7A',
};

interface GenderAccentProps {
  gender: number | undefined;
}

export function GenderAccent({ gender }: GenderAccentProps) {
  const accent = gender !== undefined ? GENDER_ACCENT[gender] : undefined;

  return (
    <div
      aria-hidden="true"
      className="fixed top-0 bottom-0 left-0 w-[7px] z-[60] transition-opacity duration-300 pointer-events-none"
      style={{ backgroundColor: accent ?? 'transparent', opacity: accent ? 1 : 0 }}
    />
  );
}
